// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__ELjSM","container":"styles_container__5VmcW","title":"styles_title__3E7m0","text":"styles_text__UTuLg","closeIcon":"styles_closeIcon__Gby77"};